import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { OrgDocumentResp } from 'types/event/eventStep5'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import DocumentForm from '../../ModalCotent/RequiredDocument/DocumentForm'

interface AddDocumentProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  organizationId: string
  data: OrgDocumentResp | undefined
}

const AddDocument: React.FC<AddDocumentProps> = ({
  openModal,
  setOpenModal,
  organizationId,
  data,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const hanldeClose = () => {
    setOpenModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={hanldeClose}
        title="Add document"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            closeModal={hanldeClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <DocumentForm
          form={form}
          organizationId={organizationId}
          data={data}
          setOpenModal={setOpenModal}
        />
      </CustomModal>
    </>
  )
}

export default AddDocument
